import React, { useState, useEffect } from "react";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const TwoDigitInput = (props) => {
  const [inputValue, setInputValue] = useState(props.initialValue || "");
  const isLoading = props.isLoading;

  useEffect(() => {
    setInputValue(props.initialValue);
  }, [props.initialValue]);

  const handleInputChange = (event) => {
    const newInputValue = event.target.value.replace(/[^0-9]/g, "");
    if (newInputValue.length <= 2) {
      setInputValue(newInputValue.slice(0, 2));
    }
  };

  const handleInputBlur = () => {
    props.onBlur(inputValue);
  };

  return (
    <div className={`${props.className}`}>
      <label
        htmlFor={props.id}
        className="block text-sm font-medium text-gray-700"
      >
        {props.label}
      </label>
      {!isLoading ? (
        <input
          id={props.id}
          name={props.id}
          type="text"
          autoComplete="off"
          tabIndex={-1}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          placeholder={props.placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          maxLength={2}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
        />
      ) : (
        <TextSkeleton height="38px" className="mt-1 w-full" />
      )}
    </div>
  );
};

export default TwoDigitInput;
